import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const sectionPackages = () => {
  const sections = document.querySelectorAll('.js-section-packages-anim');
  const formSections = document.querySelectorAll(
    '.js-section-packages-form-anim',
  );

  if (sections.length !== 0) {
    sections.forEach(section => {
      const bg = Snap(section);
      if (bg) {
        createTriangle(bg, 40, -130, 900, 50, 10);
        createTriangle(bg, 80, -60, 420, 420, 25);
        createTriangle(bg, 120, -140, 1400, 300, 40);
      }
    });
  }

  if (formSections.length !== 0) {
    formSections.forEach(section => {
      const bg = Snap(section);
      if (bg) {
        createTriangle(bg, 40, -30, 1350, 670, 20);
        createTriangle(bg, 90, -110, 510, 70, 30);
      }
    });
  }
};

export default sectionPackages;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/section-packages.js